// @ts-nocheck
/* eslint-disable */
export const llaPlatformTickIcon = {
    data: `<svg viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.45001 1.33984L3.22998 5.5498L1.28003 3.60986" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'tick' as const
};